import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const expiresAt = localStorage.getItem('token_expires_at');
  
  // 检查token是否存在
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  // 检查token是否过期（1天）
  if (expiresAt) {
    const expirationTime = new Date(expiresAt);
    const now = new Date();
    
    if (now > expirationTime) {
      // Token已过期，清除所有登录信息并重定向到登录页
      localStorage.removeItem('token');
      localStorage.removeItem('token_expires_at');
      localStorage.removeItem('user');
      return <Navigate to="/login" replace />;
    }
  }
  
  return children;
};

export default ProtectedRoute;

